import React from "react";
import Tile from "./tile";
import "../components.css";


export default function Empty ({ width = "25vw", height = "25vh" }) {
    const style = {
        width: width,
        height: height
    }

    return (
        <Tile style={style}/>
    )
}
